import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SalesConversionTab } from './tabs/SalesConversionTab';
import { StockCoverageTab } from './tabs/StockCoverageTab';
import { ReturnsQualityTab } from './tabs/ReturnsQualityTab';
import { AdsTab } from './tabs/AdsTab';
import { LogisticsTab } from './tabs/LogisticsTab';
import { FeesMarginTab } from './tabs/FeesMarginTab';
import { CustomerServiceTab } from './tabs/CustomerServiceTab';
import { AgencyKpisTab } from './tabs/AgencyKpisTab';
import type { FilterState } from './GlobalFilters';

interface DashboardTabsProps {
  clientId: string;
  filters: FilterState;
}

export function DashboardTabs({ clientId, filters }: DashboardTabsProps) {
  return (
    <Tabs defaultValue="ventes" className="space-y-4">
      <TabsList className="grid w-full grid-cols-4 lg:grid-cols-8">
        <TabsTrigger value="ventes">Ventes</TabsTrigger>
        <TabsTrigger value="stocks">Stocks</TabsTrigger>
        <TabsTrigger value="retours">Retours</TabsTrigger>
        <TabsTrigger value="publicite">Publicité</TabsTrigger>
        <TabsTrigger value="logistique">Logistique</TabsTrigger>
        <TabsTrigger value="frais">Frais</TabsTrigger>
        <TabsTrigger value="service">Service</TabsTrigger>
        <TabsTrigger value="agence">Agence</TabsTrigger>
      </TabsList>

      <TabsContent value="ventes">
        <SalesConversionTab clientId={clientId} filters={filters} />
      </TabsContent>

      <TabsContent value="stocks">
        <StockCoverageTab clientId={clientId} filters={filters} />
      </TabsContent>

      <TabsContent value="retours">
        <ReturnsQualityTab clientId={clientId} filters={filters} />
      </TabsContent>

      <TabsContent value="publicite">
        <AdsTab clientId={clientId} filters={filters} />
      </TabsContent>

      <TabsContent value="logistique">
        <LogisticsTab clientId={clientId} filters={filters} />
      </TabsContent>

      <TabsContent value="frais">
        <FeesMarginTab clientId={clientId} filters={filters} />
      </TabsContent>

      <TabsContent value="service">
        <CustomerServiceTab clientId={clientId} filters={filters} />
      </TabsContent>

      <TabsContent value="agence">
        <AgencyKpisTab clientId={clientId} filters={filters} />
      </TabsContent>
    </Tabs>
  );
}